import { useState } from 'react';
import { Button } from 'react-bootstrap';
import styles from './SessionSetup.module.css';

// Convert ISO string to local datetime-local format (YYYY-MM-DDTHH:mm)
function toLocalDatetimeString(isoString) {
  if (!isoString) return '';
  const date = new Date(isoString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

export function SessionHeader({ session, onSave }) {
  const [isEditing, setIsEditing] = useState(false);
  const [editName, setEditName] = useState(session.name || '');
  const [editStartAt, setEditStartAt] = useState(
    toLocalDatetimeString(session.startAt)
  );
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    try {
      await onSave({
        name: editName,
        startAt: editStartAt ? new Date(editStartAt).toISOString() : null,
      });
      setIsEditing(false);
    } catch (err) {
      console.error('Failed to save header:', err);
      alert('Failed to save changes: ' + err.message);
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    setEditName(session.name || '');
    setEditStartAt(toLocalDatetimeString(session.startAt));
    setIsEditing(false);
  };

  if (isEditing) {
    return (
      <div className={styles.header}>
        <div className={styles.headerEditForm}>
          <input
            type="text"
            className={styles.headerEditInput}
            value={editName}
            onChange={(e) => setEditName(e.target.value)}
            placeholder="Session name"
          />
          <input
            type="datetime-local"
            className={styles.headerEditInput}
            value={editStartAt}
            onChange={(e) => setEditStartAt(e.target.value)}
          />
        </div>
        <div className={styles.headerRight}>
          <Button
            size="sm"
            variant="outline-secondary"
            onClick={handleCancel}
            disabled={saving}
          >
            Cancel
          </Button>
          <Button
            size="sm"
            variant="primary"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? 'Saving...' : 'Save'}
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.header}>
      <h1>{session.name || 'Session Setup'}</h1>
      <div className={styles.headerRight}>
        <span className={styles.startTime}>
          {session.startAt
            ? new Date(session.startAt).toLocaleDateString('en-US', {
                weekday: 'short',
                month: 'short',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: '2-digit',
              })
            : 'No start time'}
        </span>
        <button
          className={styles.sessionLink}
          title="Edit session name and time"
          onClick={() => setIsEditing(true)}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
          </svg>
        </button>
        <a
          href={`/session?s=${session.sessionKey}`}
          className={styles.sessionLink}
          title="Go to session"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
            <polyline points="15 3 21 3 21 9" />
            <line x1="10" y1="14" x2="21" y2="3" />
          </svg>
        </a>
      </div>
    </div>
  );
}
